import useNavigationStore from "@src/stores/navigationStore";
import CompanyMisc from "./CompanyMisc";
import SirenNumber from "./SirenNumber";
import CompanyInformations from "./CompanyInformations";
import Various from "./Various";
import Beneficiaries from "./Beneficiaries";
import BeneficiariesInformations from "./BeneficiariesInformations";

const componentMap = {
    Beneficiaries: Beneficiaries,
    BeneficiariesInformations: BeneficiariesInformations,
    CompanyMisc: CompanyMisc,
    SirenNumber: SirenNumber,
    CompanyInformations: CompanyInformations,
    Various: Various,
};

export default function ThirdSection() {
    const { section } = useNavigationStore();

    const SelectedComponent = componentMap[section.block as keyof typeof componentMap] || null;

    return <>{SelectedComponent ? <SelectedComponent /> : null}</>;
}
